import Vue from 'vue';

// Photos for nature camps. If a camp has a custom uploaded image/banner,
// return its served URL. Otherwise, fallback to one of the static photos
// deterministically picked from the camp id so it always shows the same picture.
const CAMP_PHOTOS = [
  require("@/assets/Images/kerala_periyar_camp.jpg"),
  require("@/assets/Images/kerala_wayanad_camp.jpg"),
  require("@/assets/Images/kerala_camp_hero_card_1.jpg"),
  require("@/assets/Images/ibimage12.jpg"),
];

export function campPhoto(idOrItem, maybeImage) {
  let img = maybeImage;
  let id = idOrItem;

  if (idOrItem && typeof idOrItem === 'object') {
    img = idOrItem.image;
    id = idOrItem._id || idOrItem.id || idOrItem.campName || '';
  }

  if (img) {
    if (typeof img === 'string' && (img.startsWith('http://') || img.startsWith('https://') || img.startsWith('data:'))) {
      return img;
    }
    const mediaURL = (Vue.prototype && Vue.prototype.mediaURL) ||
      (window.axios && window.axios.defaults && window.axios.defaults.baseURL
        ? window.axios.defaults.baseURL.replace(/\/$/, '') + '/file/get/'
        : '/file/get/');
    return mediaURL.endsWith('/') ? `${mediaURL}${img}` : `${mediaURL}/${img}`;
  }

  const key = String(id || "");
  let hash = 0;
  for (let k = 0; k < key.length; k++) hash = (hash * 31 + key.charCodeAt(k)) >>> 0;
  return CAMP_PHOTOS[hash % CAMP_PHOTOS.length];
}

